import classNames from 'classnames';
import { FC, ReactElement, memo, useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IResponseProductExclusion } from 'src/types/products';
import Text from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  exclusions: IResponseProductExclusion[] | undefined;
}

export const OrderCartProductExclusions: FC<IProps> = memo((props: IProps): ReactElement | null => {
  const exclusions = useMemo((): IResponseProductExclusion[] => {
    if (!props.exclusions?.length) return [];

    return props.exclusions.filter((exclusion) => exclusion.selected);
  }, [props.exclusions]);

  if (!exclusions.length) return null;

  return (
    <div className="order-cart-product-exclusions">
      <p className="order-cart-product-exclusions__header letter-spacing-12">{localeStore.t('Exclusions')}</p>

      {exclusions.map((exclusion) => (
        <Text key={exclusion.id} type="cart-option" text={exclusion.name} className={classNames({ through: !exclusion.status })} />
      ))}
    </div>
  );
});
